import React, { useState } from 'react';
import { verifyCode } from '../services/authService';
import styles from '../signin.module.css';

const VerifyCode = ({ email, onSuccess }) => {
    const [code, setCode] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            await verifyCode(email, code);
            onSuccess(); // Proceed after successful verification
        } catch (err) {
            setError('Invalid code. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.container}>
            <form onSubmit={handleSubmit}>
                <p className={styles.message}>We sent a verification code to {email}.</p>

                <label htmlFor="code" className={styles.label}>Enter the code</label>

                <input
                    type="text"
                    id="code"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    required
                    autoComplete='off'
                    className={styles.input}
                />
                <button type="submit" disabled={loading} className={styles.button}>
                    {loading ? 'Verifying...' : 'Verify'}
                </button>
                {error && <p className={styles.error}>{error}</p>}
            </form>
        </div>
    );
};

export default VerifyCode;